document.addEventListener("DOMContentLoaded", function () {
  const mountedDom = document.querySelector(".bm_top_product_div");
  const pointsContentDom = document.querySelector(".bm_product_points");
  const moneyContainer = document.querySelector('.price-container');
  const moneyElement = moneyContainer.querySelector(".langwill-money");
  
  function addImageAndStyles() {
    const hasMounted = !!mountedDom.querySelector("img[alt='LoloyalLabel']");
    let contentText = pointsContentDom.textContent.trim();
    const contentNotNull = contentText !== "";
    
    if (contentNotNull && contentText.includes("{price}")) {
      if (moneyElement) {
        const moneyText = moneyElement.textContent.trim();
        // Remove the currency symbol and remove ','
        const currencyMatch = moneyText.match(/\$|¥|€/);
        const numericString = moneyText.replace(/[AUDCEUR$¥€]/g, '').replace(/,/g, '');
        const numericValue = parseFloat(numericString);
        
        if (!isNaN(numericValue) && currencyMatch[0]) {
          
          const calculatedPrice = numericValue / 100
          let formattedPrice;
          
          if (Number.isInteger(calculatedPrice)) {
            formattedPrice = calculatedPrice.toString();
          } else {
            formattedPrice = calculatedPrice.toFixed(2)
          }
          
          contentText = contentText.replace(/\{price\}/g, currencyMatch[0] + formattedPrice);
          pointsContentDom.textContent = contentText;
        }
      }
    }
    
    if (contentNotNull && !hasMounted) {
      const img = document.createElement("img");
      img.src = "https://static.loloyal.com/m/id/60976595185/1745571895.svg";
      img.alt = "LoloyalLabel";
      img.style.cssText = "margin-right:4px;width:24px;height:24px;";
      mountedDom.style.cssText = "display:inline-flex;align-items:center;padding:4px 8px;border-radius:6px;background:#fdf0f0;";
      pointsContentDom.style.cssText = "color:#D02F25;";
      mountedDom.prepend(img);
      // observer.disconnect();
    }
  }
  
  const observer = new MutationObserver(function(mutations) {
    addImageAndStyles();
  });

  const observerMoneyContainer = new MutationObserver(function(mutations) {
    addImageAndStyles();
  });
  
  const config = {
    childList: true,
    characterData: true,
    subtree: true
  };
  
  observer.observe(pointsContentDom, config);
  observer.observe(moneyElement, config);
});